module.exports = __webpack_public_path__ + "static/agreeing-disagreeing-979cce263f27cc38bb102c26fd1aa8b3.jpg";